import { constants } from '../../constants';
import { formatUtils, numericUtils } from '../../utils';

interface GuidanceChgProps {
    guidanceChg?: number;
}

export function GuidanceChg({ guidanceChg }: GuidanceChgProps) {
    if (guidanceChg == null) return <>{constants.emptyPlaceholder}</>;

    const rounded = numericUtils.round(guidanceChg, 1);

    if (rounded === 0) return <span>0</span>;

    const formatted = formatUtils.formatDecimal(rounded, 1);

    return <span>{rounded > 0 ? `+${formatted}` : formatted}</span>;
}
